<template>
  <div>
    <h1 class="font-weight-bold text-uppercase">
      Planos de assinatura do Profissional 
      <i v-b-modal.novo-plano class="fas fa-plus-square newPlan"></i>
    </h1>
    <hr class="linha-amarela" />
    <table class="table">
      <thead class="thead-dark">
        <tr>
          <th style="width:20%">Plano</th>
          <th style="width:10%">Preço</th>
          <th style="width:25%">Descrição</th>
          <th style="width:8%">Ordem</th>
          <th style="width:8%">Recomendado</th>
          <th style="width:8%">Mostrar</th>
          <th style="width:8%">Status</th>
          <th style="width:13%">Ações</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(item, i) in planos" :key="i">
          <td>{{item.nome}}</td>
          <td>{{item.preco}}</td>
          <td>{{item.descricao.substr(0, 60)}}{{item.descricao.length > 60 ? '...' : ''}}</td>
          <td>{{item.ordem ? item.ordem : '-'}}</td>
          <td>{{validAdd(item.recomendado, 'Sim', 'Não')}}</td>
          <td>{{validAdd(item.mostrar, 'Mostrar', 'Não mostrar')}}</td>
          <td>{{validAdd(item.status)}}</td>
          <td>
            <i class="fas fa-copy mr-2 iconCursor" @click="copiarUrlPagamento(item.id, true)" title="Pagamento cartão e pix" style="color: blue"></i>
            <i class="fas fa-copy mr-2 iconCursor" @click="copiarUrlPagamento(item.id)" title="Pagamento cartão"></i>
            <i class="fas fa-pen mr-2 iconCursor" @click="editar(item)"></i>
            <i class="fas fa-ban mr-2 iconCursor" @click="inativar(item.id, item.status)"></i>
            <i class="fas fa-trash iconCursor" @click="excluir(item.id)"></i>
          </td>
        </tr>
      </tbody>
    </table>

  <b-modal id="novo-plano" size="lg" title="Novo plano Profissional" hide-footer>
    <div class="row">
      <div class="col-md-8">
        <label>Nome do plano</label>
        <input type="text" class="form-control" v-model="Fields.nome" placeholder="Digite o nome do plano">
      </div>

      <div class="col-md-2">
        <label>Recomendado</label>
        <input type="checkbox" v-model="Fields.recomendado" class="form-control">
      </div>

      <div class="col-md-2">
        <label>Mostrar</label>
        <input type="checkbox" v-model="Fields.mostrar" class="form-control">
      </div>
    </div>

    <div class="row">
      <div class="col-md-4">
        <label>Preço do plano</label>
        <input type="text" v-model="Fields.preco" v-money="money" class="form-control">
      </div>
      
      <div class="col-md-6">
        <label>Preço do plano escrito</label>
        <input type="text" v-model="Fields.preco_text" class="form-control">
      </div>

      <div class="col-md-2">
        <label>Ordem listagem</label>
        <input type="number" v-model="Fields.ordem" class="form-control" placeholder="Ex: 1">
      </div>
    </div>

    <div class="row mt-2">
      <div class="col-md-12">
        <label>Url da imagem do plano</label>
        <input type="text" class="form-control" v-model="Fields.url_img" placeholder="Link da URL do plano">
      </div>
    </div>

    <div class="row mt-2">
      <div class="col-md-12">
        <label>Descricão do plano</label>
        <textarea rows="3" class="form-control" v-model="Fields.descricao"></textarea>
      </div>
    </div>

    <div class="row mt-2">
      <div class="col-md-12">
        <button @click="novoPlano()" class="btn btn-success btn-block">Criar plano</button>
      </div>
    </div>
  </b-modal>

  <b-modal id="novo-plano-up" size="lg" title="Atualizar plano Profissional" hide-footer>
    
    <div class="row">
      <div class="col-md-8">
        <label>Nome do plano</label>
        <input type="text" class="form-control" v-model="FieldsUp.nome" placeholder="Digite o nome do plano">
      </div>

      <div class="col-md-2">
        <label>Recomendado</label>
        <input type="checkbox" v-model="FieldsUp.recomendado" class="form-control">
      </div>

      <div class="col-md-2">
        <label>Mostrar</label>
        <input type="checkbox" v-model="FieldsUp.mostrar" class="form-control">
      </div>
    </div>

    <div class="row">
      <div class="col-md-4">
        <label>Preço do plano</label>
        <input type="text" v-model="FieldsUp.preco" v-money="money" class="form-control">
      </div>
      
      <div class="col-md-6">
        <label>Preço do plano escrito</label>
        <input type="text" v-model="FieldsUp.preco_text" class="form-control">
      </div>

      <div class="col-md-2">
        <label>Ordem listagem</label>
        <input type="number" v-model="FieldsUp.ordem" class="form-control" placeholder="Ex: 1">
      </div>
    </div>

    <div class="row mt-2">
      <div class="col-md-12">
        <label>Url da imagem do plano</label>
        <input type="text" class="form-control" v-model="FieldsUp.url_img" placeholder="Link da URL do plano">
      </div>
    </div>

    <div class="row mt-2">
      <div class="col-md-12">
        <label>Descricão do plano</label>
        <textarea rows="3" class="form-control" v-model="FieldsUp.descricao"></textarea>
      </div>
    </div>

    <div class="row mt-2">
      <div class="col-md-12">
        <button @click="alterarPlano()" class="btn btn-success btn-block">Alterar plano</button>
      </div>
    </div>
  </b-modal>
  </div>
</template>

<script>
import makeToast from '@/mixins/makeToast';
export default {
  name: 'ProfissionalAssinatura',
  mixins: [makeToast],
  data() {
    return {
      valid: false,
      planos: [],
      Fields: {
        nome: '',
        preco: '',
        preco_text: '',
        ordem: null,
        mostrar: false,
        recomendado: false,
        url_img: '',
        descricao: ''
      },
      FieldsUp: {
        id: '',
        nome: '',
        preco: '',
        preco_text: '',
        ordem: null,
        mostrar: false,
        recomendado: false,
        url_img: '',
        descricao: ''
      },
      money: {
        decimal: ',',
        thousands: '.',
        prefix: 'R$ ',
        suffix: '',
        precision: 2,
        masked: true,
      },
    }
  },

  created() {
    this.showPlanos();
  },

  methods: {
    validAdd(v, text1='Ativo', text2='Inativo') {
      return v == true ? text1 : text2
    },
    copiarUrlPagamento(id, pix = false) {
      var valid = 'false';
      if(pix == true) {
        valid = 'true';
      }

      const url = process.env.VUE_APP_CURRENT_SITE_ADDRESS+'/cadastro-assinatura-profissional/'+btoa(id)+'?parametro='+btoa(valid);
      navigator.clipboard.writeText(url);
      this.makeToast('Sucesso!', 'Link copiado com sucesso!', 'success');
    },
    editar(item){
      this.FieldsUp.id = item.id;
      this.FieldsUp.nome = item.nome;
      this.FieldsUp.preco = item.preco;
      this.FieldsUp.preco_text = item.preco_text;
      this.FieldsUp.url_img = item.url_img;
      this.FieldsUp.mostrar = item.mostrar;
      this.FieldsUp.recomendado = item.recomendado;
      this.FieldsUp.ordem = item.ordem;
      this.FieldsUp.descricao = item.descricao;
      this.$bvModal.show('novo-plano-up');
    },
    alterarPlano() {
      this.$store.dispatch('startLoader');
      this.$store.dispatch('admin/alterarPlanoProfissional', this.FieldsUp)
      .then((response) => {
        if(response.data.message == 'success') {
          this.$bvModal.hide('novo-plano-up');
          this.makeToast('Sucesso', 'Plano atualizado com sucess!', 'success');
          this.showPlanos();
        } else {
          this.makeToast('Oopss', 'Oops! Parece que houve um erro ao atualizar plano!', 'danger');
        }
      })
      .catch(() => {
        this.makeToast('Oopss', 'Oops! Parece que houve um erro ao atualizar plano!', 'danger');
      })
      .finally(() => {
        this.$store.dispatch('endLoader');
      })
    },
    novoPlano() {
      this.$store.dispatch('startLoader');
      this.$store.dispatch('admin/novoPlanoProfissional', this.Fields)
      .then((response) => {
        if(response.data.message == "success") {
          this.$bvModal.hide('novo-plano');
          this.limparCampos()
          this.makeToast('Sucesso', 'Plano criado com sucess!', 'success');
          this.showPlanos();
        } else {
          this.makeToast('Oopss', 'Parece que houve um erro ao criar plano!', 'danger');
        }
      })
      .catch(() => {
        this.makeToast('Oopss', 'Parece que houve um erro ao criar plano!', 'danger');
      })
      .finally(() => {
        this.$store.dispatch('endLoader');
      })
    },
    inativar(id, status) {
      if(status == false && this.valid == true) {
        this.makeToast('Oopss', 'Você só pode ter um plano ativo!', 'danger');
        return;
      }

      this.$store.dispatch('startLoader');
      this.$store.dispatch('admin/inativarPlanoProfissional', id)
      .then((response) => {
        if(response.data.message == 'success') {
          this.makeToast('Sucesso', 'Status do plano alterado com sucess!', 'success');
          this.showPlanos()
        } else {
          this.makeToast('Oopss', 'Parece que houve um erro ao inativar plano!', 'danger');
        }
      })
      .catch(() => {
        this.makeToast('Oopss', 'Parece que houve um erro ao alterar status plano!', 'danger');
      })
      .finally(() => {
        this.$store.dispatch('endLoader');
      })
    },
    excluir(id) {
      this.$store.dispatch('startLoader');
      this.$store.dispatch('admin/excluirPlanoProfissional', id)
      .then((response) => {
        if(response.data.message == 'success') {
          this.makeToast('Sucesso', 'Plano excluido com sucess!', 'success');
          this.showPlanos()
        } else {
          this.makeToast('Oopss', 'Oops! Parece que houve um erro ao excluir o plano!', 'danger');
        }
      })
      .catch(() => {
        this.makeToast('Oopss', 'Oops! Parece que houve um erro ao excluir o plano!', 'danger');
      })
      .finally(() => {
        this.$store.dispatch('endLoader');
      })
    },
    showPlanos() {
      this.$store.dispatch('startLoader');
      this.$store.dispatch('admin/showPlanosProfissional')
      .then((response) => {
        this.planos = response.data.data;
        this.$store.dispatch('endLoader');
      })
    },
    limparCampos() {
      this.Fields.nome = '';
      this.Fields.preco = '';
      this.Fields.preco_text = '';
      this.Fields.ordem = null;
      this.Fields.mostrar = false;
      this.Fields.recomendado = false;
      this.Fields.descricao = '';
      this.Fields.url_img = '';
    }
  }
};
</script>

<style scoped>
.newPlan {
  float: right;
}
.iconCursor {
  cursor: pointer;
}
</style>
